import enUS from './en-US.json'
import esES from './es-ES.json'
import frFR from './fr-FR.json'
import ptBR from './pt-BR.json'

export default {
  'en-US': enUS,
  'es-ES': esES,
  'pt-BR': ptBR,
  'fr-FR': frFR
}
